import {FC} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'

import CommentsPage from '../modules/apps/comment/CommentsPage'
import ContactUsPage from '../modules/apps/contact-us/ContactUsPage'
import BlogsPage from '../modules/apps/blog/BlogsPage'
import JobsPage from '../modules/apps/job/JobsPage'
import ApplicationsPage from '../modules/apps/application/ApplicationsPage'
import DashboardWrapper from '../pages/dashboard/core/DashboardWrapper'

const PrivateRoutes: FC = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to dashboard after login/registration */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />

        {/* Static Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='comment/*' element={<CommentsPage />} />
        <Route path='blogs/*' element={<BlogsPage />} />
        <Route path='contact-us/*' element={<ContactUsPage />} />
        <Route path='jobs/*' element={<JobsPage />} />
        <Route path='applications/*' element={<ApplicationsPage />} />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
